import React from 'react';
import { makeStyles } from '@material-ui/core';
import { numberToFraction } from '../utils/gameUtils';

export const styles = makeStyles(theme => ({
    odds: {
        fontSize: 14,
        margin: 0,
        textAlign: 'center',
        lineHeight: 1.5,
        letterSpacing: 0.3,
    },
}));

export const TwoValue = ({firstValue, secondValue, type, isHome}) => {
	const classes = styles();
  
	return (
    	<>
            {
                firstValue &&
                <div className={classes.odds}>{numberToFraction(firstValue, type, isHome)}<span>&nbsp;</span></div>
            }
            <div className={classes.odds}>{secondValue}</div>
        </>
	);
}